/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import WillPaginateCollection from './will_paginate_collection'
import ExampleActivity from './example_activity'

// @namespace Model
class ExampleActivities extends WillPaginateCollection {
  static initClass () {
    this.prototype.model = ExampleActivity
    this.prototype.url = '/api/examples'
  }
}
ExampleActivities.initClass()

export default ExampleActivities
